module.exports = {
	"API": {
		"url": "http://localhost",
		"port": 3000
	},
	"client": {
		"url": "http://localhost",
		"port": 4000
	},
	"app": {
		"tweet": {
			"numberPerRequest": 60
		},
		"lang": "en"
	},
	"production": {
		"API_URL": "https://tweetscape.herokuapp.com"
	}
};


//////////////////
// WEBPACK FOOTER
// ./settings/default.json
// module id = 155
// module chunks = 2